import React, { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootStateOrAny } from "react-redux";

import AVLiveHostPopup from "./AVLiveHostPopup";
import AVLiveViewPopup from "./AVLiveViewPopup";

import {
  setShowLiveHostModal,
  setShowLiveViewModal,
  setShowLiveViewer,
} from "../../Redux/Actions/liveStreamActions";

const FLOAT_WIDTH = 360;
const FLOAT_HEIGHT = 200;

const AVLiveStreamContainer = () => {
  const dispatch = useDispatch();

  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user?.[0],
  );

  const {
    showLiveHostModal,
    showLiveViewModal,
    showLiveViewer,
    entity,
    isHostLiveMinimized,
    isViewLiveMinimized,
  } = useSelector((state: RootStateOrAny) => state.liveStream);

  const [position, setPosition] = useState({
    x: window.innerWidth - FLOAT_WIDTH - 20,
    y: window.innerHeight - FLOAT_HEIGHT - 20,
  });

  const dragRef = useRef(false);
  const offsetRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!dragRef.current) return;

      setPosition({
        x: Math.max(
          0,
          Math.min(
            e.clientX - offsetRef.current.x,
            window.innerWidth - FLOAT_WIDTH,
          ),
        ),
        y: Math.max(
          0,
          Math.min(
            e.clientY - offsetRef.current.y,
            window.innerHeight - FLOAT_HEIGHT,
          ),
        ),
      });
    };

    const handleMouseUp = () => {
      dragRef.current = false;
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    dragRef.current = true;

    offsetRef.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
  };

  const floatingStyle: React.CSSProperties = {
    position: "fixed",
    left: `${position.x}px`,
    top: `${position.y}px`,
    width: FLOAT_WIDTH,
    height: FLOAT_HEIGHT,
    zIndex: 99999,
    borderRadius: 12,
    overflow: "hidden",
    background: "transparent",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    cursor: "move",
  };

  return (
    <>
      {/* Host Popup */}
      {showLiveHostModal && (
        <div
          style={isHostLiveMinimized ? floatingStyle : {}}
          onMouseDown={isHostLiveMinimized ? handleMouseDown : undefined}
        >
          <AVLiveHostPopup
            host={currentUser}
            owner={entity}
            showLiveHost={showLiveViewer}
            setShowLiveViewer={(data) => dispatch(setShowLiveViewer(data))}
            isHuddlePostTab={entity?.type === "Channel"}
            onClose={() => dispatch(setShowLiveHostModal(false))}
          />
        </div>
      )}

      {/* Viewer Popup */}
      {showLiveViewModal && (
        <div
          style={isViewLiveMinimized ? floatingStyle : {}}
          onMouseDown={isViewLiveMinimized ? handleMouseDown : undefined}
        >
          <AVLiveViewPopup
            showLiveViewer={showLiveViewer}
            onClose={() => {
              dispatch(setShowLiveViewModal(false));
              dispatch(setShowLiveViewer(null));
            }}
          />
        </div>
      )}
    </>
  );
};

export default AVLiveStreamContainer;
